import { Button,  Col, Form, Input, Modal, Row, Select, message } from "antd";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import { fetchOptions } from "../../../../api/options";
import extractOptions from "../../../../utils/extractOptions";
import { addProductSpec } from "../../../../api/products";

const { Option } = Select;

export default function CreateSpec({
  isVisible,
  setVisible,
  product,
  productId,
}: any) {
  const queryClient = useQueryClient();
  const [option, setOption] = useState<any>({});

  const { data } = useQuery({
    queryKey: ["options"],
    queryFn: fetchOptions,
  });

  const options = extractOptions(data, product?.details);

  const [form] = Form.useForm();

  const { mutate, isLoading } = useMutation({
    mutationFn: addProductSpec,
    onError: (error) => {
      message.error(`${error}`);
    },
    onSuccess: () => {
      message.success("Added Successfully");
      form.resetFields();
      queryClient.invalidateQueries({ queryKey: ["products", productId] });
      setVisible(false);
    },
  });

  const handleSelected = (id: any) => {
    const filtered = options?.filter((option: any) => option.id === id);
    setOption(filtered[0]);
  };

  const optOptions = options?.map((option: any, index: number) => (
    <Option value={option?.id} key={index}>
      {option?.name}
    </Option>
  ));

  const onSubmit = async () => {
    const { value } = await form.validateFields();
    const data = {
      name: option?.name,
      icon: option?.icon,
      option_id: option?.id,
      value,
      product_id: Number(productId),
    };
    mutate({ id: productId, data });
  };

  return (
    <Modal
      title="Add Spec"
      open={isVisible}
      onCancel={() => setVisible(false)}
      footer={[
        <Button key="back" onClick={() => setVisible(false)}>
          Cancel
        </Button>,
        <Button
          key="submit"
          form="addProductSpec"
          htmlType="submit"
          onSubmit={onSubmit}
          loading={isLoading}
          className="border-0 bg-blue-600 text-white"
        >
          Submit
        </Button>,
      ]}
    >
      <Form
        id="addProductSpec"
        form={form}
        name="control-ref"
        onFinish={onSubmit}
        layout="vertical"
      >
        <Row gutter={[16, 0]}>
          <Col xs={{ span: 24 }} lg={{ span: 24 }}>
            <Form.Item
              name="option_id"
              label="Option"
              rules={[
                {
                  required: true,
                  message: "Please enter region",
                },
              ]}
            >
              <Select placeholder="Option" onSelect={(e) => handleSelected(e)}>
                {optOptions}
              </Select>
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={[16, 0]}>
          <Col xs={{ span: 24 }} lg={{ span: 24 }}>
            <Form.Item
              name="value"
              label="Value"
              rules={[
                {
                  required: true,
                  message: "Please enter value",
                },
              ]}
            >
              <Input placeholder="Value" />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
}
